import { safeParseNullDefault, safeParse, removeNulls } from 'shouldve-been-js';
import FilledObservationLine from './FilledObservationLineModel';

class FilledObservation {

    private _filledObservationId: string;
    private _observationId: string;
    private _name: string;
    private _createdDate: Date;
    private _changedDate: Date;
    private _observationLines: FilledObservationLine[];
    private _folderId: string;
    private _sortIndex: number;
    private _ruleSetId: string;

    public constructor(filledObservationId: string, observationId: string, name: string, createdDate: Date, changedDate: Date, observationLines: FilledObservationLine[], folderId: string, sortIndex: number, ruleSetId: string) {

        this._filledObservationId = filledObservationId;
        this._observationId = observationId;
        this._name = name;
        this._createdDate = createdDate;
        this._changedDate = changedDate;
        this._observationLines = observationLines;
        this._folderId = folderId;
        this._sortIndex = sortIndex;
        this._ruleSetId = ruleSetId;
    }

    public get filledObservationId(): string {
        return this._filledObservationId;
    }

    public set filledObservationId(value: string) {
        this._filledObservationId = value;
    }

    public get observationId(): string {
        return this._observationId;
    }

    public set observationId(value: string) {
        this._observationId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get createdDate(): Date {
        return this._createdDate;
    }

    public set createdDate(value: Date) {
        this._createdDate = value;
    }

    public get changedDate(): Date {
        return this._changedDate;
    }

    public set changedDate(value: Date) {
        this._changedDate = value;
    }

    public get observationLines(): FilledObservationLine[] {
        return this._observationLines;
    }

    public set observationLines(value: FilledObservationLine[]) {
        this._observationLines = value;
    }

    public get folderId(): string {
        return this._folderId;
    }

    public set folderId(value: string) {
        this._folderId = value;
    }

    public get sortIndex(): number {
        return this._sortIndex;
    }

    public set sortIndex(value: number) {
        this._sortIndex = value;
    }

    public get ruleSetId(): string {
        return this._ruleSetId;
    }

    public set ruleSetId(value: string) {
        this._ruleSetId = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): FilledObservation | null {

        const filledObservationId: string | null = safeParseNullDefault<string>(object?._filledObservationId, '');
        const observationId: string | null = safeParseNullDefault<string>(object?._observationId, '');
        const name: string = safeParse<string>(object?._name, '');
        const createdDate: Date | null = safeParseNullDefault<Date>(object?._createdDate, new Date());
        const changedDate: Date | null = safeParseNullDefault<Date>(object?._changedDate, new Date());
        const folderId: string | null = safeParseNullDefault<string>(object?._folderId, '');
        const sortIndex: number | null = safeParseNullDefault<number>(object?._sortIndex, 0);
        const ruleSetId: string | null = safeParseNullDefault<string>(object?._ruleSetId, '');

        if (filledObservationId === null || observationId === null || createdDate === null || changedDate === null || folderId === null || sortIndex === null || ruleSetId === null || filledObservationId === '' || observationId === '' || folderId === '') {
            return null;
        }

        if (!Array.isArray(object?._observationLines)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        const observationLines: (FilledObservationLine | null)[] = object._observationLines.map((observationLineObject: any) => {
            return FilledObservationLine.fromIndexedDB(observationLineObject);
        });   

        return new FilledObservation(filledObservationId, observationId, name, createdDate, changedDate, removeNulls(observationLines), folderId, sortIndex, ruleSetId);
    }
}

export default FilledObservation;